export const EUR_CURRENCY_ID = '0802df1e-4a98-4c20-98d0-2e28767b4329';
